import Vue from 'vue';

export class BookingPhase {
    id: number;
    name: string;
    color: string;

    klass: object = BookingPhase;

    constructor(id: number, name: string) {
      this.id = id;
      this.name = name;
    }

}

export default BookingPhase;
